import { useEffect, useState } from 'react';
import * as interfaces from '../interfaces';

export function useApplyFilterAndSearch<T extends interfaces.AnswerInterface | interfaces.QuestionInterface>(props: {
  search: string;
  filter: string[];
}) {
  const { search = '', filter = [] as string[] } = props;
  const [originalItems, setOriginalItems]: [T[], (v: T[]) => void] = useState([] as T[]);
  const [mappedItems, setMappedItems]: [T[], (v: T[]) => void | ((c: (v: T[]) => T[]) => void)] = useState([] as T[]);

  const stripedCategory = (category: string): string => {
    return category.toString().replace(/[^a-z0-9\-,]+/g, '').trim()
  }

  const stripedCategories: string[] = stripedCategory(filter.join(',')).split(',')

  useEffect(() => {
    setMappedItems(
      originalItems
        .filter((i: T) => {
          if ('question' in i)
            return (stripedCategories.length && stripedCategories.includes(stripedCategory(i.question.category))) || !stripedCategories.length || !filter.length;
          else
            return (stripedCategories.length && stripedCategories.includes(stripedCategory(i.category))) || !stripedCategories.length || !filter.length;
        })
        .filter((i: T) => {
          if ('question' in i)
            return (
              (search.length &&
                (i.question.text.toLowerCase().includes(search.toLowerCase()) ||
                  i.question.text.toLowerCase() === search.toLowerCase())) ||
              !search.length
            );
          else
            return (
              (search.length &&
                (i.text.toLowerCase().includes(search.toLowerCase()) || i.text.toLowerCase() === search.toLowerCase())) ||
              !search.length
            );
        })
    );
  }, [search, filter, setMappedItems, originalItems]);

  return {
    setOriginalItems,
    mappedItems,
    updateMappedItems: setMappedItems
  };
}
